import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';
import { getIsLinkCardActive } from '../../../router/selectors/getIsLinkCardActive';
import { getCard } from '../../selectors/getCard';
import { TStatus } from '../../../../types/model';
import { getActiveCardId } from '../../../router/selectors/getActiveCardId';
import { getBoardPermissions } from '../../selectors/getBoardPermissions';
import { getBoardIdByCardId } from '../../selectors/getBoardIdByCardId';
import { getBoard } from '../../selectors/getBoardById';
import { isBoardCardsLimitReached } from '../../selectors/isBoardCardsLimitReached';
import { getBoardIsOnSharedDrive } from '../../selectors/getBoardIsOnSharedDrive';
import { isKanbanchiUser } from './isKanbanchiUser';
import { getIsAssignedToMeWork } from '../../../router/selectors/getIsAssignedToMeWork';
import { getIsAssignedToMeActive } from '../../../router/selectors/getIsAssignedToMeActive';
import { getIsCardFromNotification } from '../../../router/selectors/getIsCardFromNotification';
import {
    NOTIFICATION_CARD_ID_SESSIONSTORAGE
} from '../../../../view/react_components/aside_panel/assigneToMe/notification/hocs/NotificationHOC/events/onLoadData';
import { ASIDE_PANEL_COLUMN_RELEASE } from '../../../../types/rest/IUserMeta';
import { getIsChatViewActive } from '../../../router/selectors/getIsChatViewActive';

export const getUserAllowCommentsColumnView = (
    state: IApplicationState,
): boolean => {
    let cardId = getActiveCardId(state);
    if (!cardId) {
        const { args } = state.router;
        if (
            getIsAssignedToMeWork(state) ||
            getIsAssignedToMeActive(state) ||
            getIsLinkCardActive(state)
        ) {
            cardId = parseInt(args[1]);
        } else if (getIsCardFromNotification(state)) {
            const data = sessionStorage.getItem(NOTIFICATION_CARD_ID_SESSIONSTORAGE);
            cardId = data && parseInt(data);
        }
    }
    const card = cardId && getCard(state, cardId);
    const boardId = getBoardIdByCardId(state, cardId);
    const boardPermissions = getBoardPermissions(state, boardId);
    const authPermissions = boardPermissions && boardPermissions.authPermissions;
    const allowEdit = authPermissions && authPermissions.allowEdit;
    if (
        card && card.status === TStatus.STATUS_SERVICE_TEMPLATE ||
        !allowEdit ||
        allowEdit &&
        (
            getBoard(state, boardId).lockDate ||
            isBoardCardsLimitReached(state, boardId, 0) ||
            getBoardIsOnSharedDrive(state, boardId) && !getAuthUser(state).allowSharedDrive
        ) ||
        getIsChatViewActive(state)
    ) {
        return false;
    }
    return true;
};
